<div class="Upcoming-Interviews-Dashboard">
  <div class="ui-head">
    <div class="ui-title">
      <span class="hdr-ic"><i class="material-icons">event</i></span>
      <h2>Upcoming Interviews</h2>
    </div>
    <div class="search-child">
      <emerald-input
        [label]="'Search'"
        [trailingIcon]="'search'"
        (keyup)="searchInterviews($event)"
        [value]="filterValue"
        ><emerald-icon
          *ngIf="filterValue?.length && filterValue.length > 0"
          [icon]="'close'"
          (click)="clearInput()"
        ></emerald-icon>
      </emerald-input>
    </div>
  </div>

  <div class="ui-table-wrap" *ngIf="filteredInterviews?.length; else noDataTemplate">
    <table class="ui-table">
      <thead>
        <tr>
          <th>Candidate</th>
          <th>Position</th>
          <th>Interviewer</th>
          <th class="c-exp">Exp</th>
          <th>Interview Date</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let it of filteredInterviews">
          <td class="c-name">{{ it.name || '—' }}</td>
          <td>{{ it.position || '—' }}</td>
          <td>{{ it.interviewer || '—' }}</td>
          <td class="c-exp">{{ it.totalExperience ? it.totalExperience + ' yrs' : '—' }}</td>
          <td><span class="c-date" *ngIf="it.date; else noDate">{{ it.date }}</span><ng-template #noDate>—</ng-template></td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-template #noDataTemplate>
    <section class="records-container" aria-label="Records section">
      <div class="empty-state">
        <h2 class="empty-state-title">{{ noDataMessage }}</h2>
        <img [src]="imageSrc" alt="{{ altText }}" class="empty-state-image" />
      </div>
    </section>
  </ng-template>
</div>
